import { render, staticRenderFns } from "./RuleComponent.vue?vue&type=template&id=d15f3c74&"
import script from "./RuleComponent.vue?vue&type=script&lang=js&"
export * from "./RuleComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports